import { useTranslation } from "react-i18next";
import styles from "./TermsFragment.module.css";
import Card from "../../common/Card";

const TermsFragment = () => {
	const { t } = useTranslation();

	// Helper function to render HTML content safely
	const renderTerm = (termKey) => {
		return { __html: t(termKey) };
	};

	return (
		<div className={styles.container}>
			<Card title={t("terms.card.title")}>
				<ol className={styles.rulesList}>
					<li dangerouslySetInnerHTML={renderTerm("terms.term1")} />
					<li dangerouslySetInnerHTML={renderTerm("terms.term2")} />
					<li dangerouslySetInnerHTML={renderTerm("terms.term3")} />
					<li dangerouslySetInnerHTML={renderTerm("terms.term4")} />
					<li>
						<span dangerouslySetInnerHTML={renderTerm("terms.term5")} />
						<ol className={styles.nestedList} type="i">
							<li dangerouslySetInnerHTML={renderTerm("terms.term5.i")} />
							<li dangerouslySetInnerHTML={renderTerm("terms.term5.ii")} />
							<li dangerouslySetInnerHTML={renderTerm("terms.term5.iii")} />
						</ol>
					</li>
					<li dangerouslySetInnerHTML={renderTerm("terms.term6")} />
					<li dangerouslySetInnerHTML={renderTerm("terms.term7")} />
					<li dangerouslySetInnerHTML={renderTerm("terms.term8")} />
					<li dangerouslySetInnerHTML={renderTerm("terms.term9")} />
					<li dangerouslySetInnerHTML={renderTerm("terms.term10")} />
					<li dangerouslySetInnerHTML={renderTerm("terms.term11")} />
					<li dangerouslySetInnerHTML={renderTerm("terms.term12")} />
					<li dangerouslySetInnerHTML={renderTerm("terms.term13")} />
					<li dangerouslySetInnerHTML={renderTerm("terms.term14")} />
					<li dangerouslySetInnerHTML={renderTerm("terms.term15")} />
					<li dangerouslySetInnerHTML={renderTerm("terms.term16")} />
					<li dangerouslySetInnerHTML={renderTerm("terms.term17")} />
					<li dangerouslySetInnerHTML={renderTerm("terms.term18")} />
					<li dangerouslySetInnerHTML={renderTerm("terms.term19")} />
					<li dangerouslySetInnerHTML={renderTerm("terms.term20")} />
					<li dangerouslySetInnerHTML={renderTerm("terms.term21")} />
					<li dangerouslySetInnerHTML={renderTerm("terms.term22")} />
					<li>
						<span dangerouslySetInnerHTML={renderTerm("terms.term23")} />
						<div className={styles.withdrawalClause} dangerouslySetInnerHTML={renderTerm("terms.term23.withdrawal")} />
					</li>
					<li dangerouslySetInnerHTML={renderTerm("terms.term24")} />
				</ol>
			</Card>
		</div>
	);
};

export default TermsFragment;
